{
  "familyId": "MET-LEN-NAUWKEURIG",
  "questions": [
    {
      "id": "MET-LEN-NAUWKEURIG-001",
      "familyId": "MET-LEN-NAUWKEURIG",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_nauwkeurig",
      "questionType": "multiple_choice",
      "question": "Een potlood is 17 cm en 4 mm lang. Hoe schrijf je dit in millimeters?",
      "options": ["174 mm", "17,4 mm", "1704 mm", "17004 mm"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "length",
            "from": "cm",
            "to": "mm",
            "value": 17.4
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Centimeters naar millimeters",
            "content": "1 cm = 10 mm. Dus 17 cm = 170 mm. Tel daar de 4 mm bij op: 170 + 4 = 174 mm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "nauwkeurig_cm_mm",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.lengte-komma-verschoven", "label": "Komma verplaatst zonder echt om te rekenen", "optionIndex": 1 },
          { "id": "met.lengte-mm-cm-relatie-fout", "label": "Denkt 1 cm = 100 mm", "optionIndex": 2 },
          { "id": "met.lengte-mm-cm-relatie-fout", "label": "Denkt 1 cm = 1.000 mm (verwart met meter)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "17 cm = 17 × 10 = 170 mm. Plus 4 mm = 174 mm. Waarom ×10? Omdat er 10 millimeter in 1 centimeter gaan. Check: 174 mm ÷ 10 = 17,4 cm ✓",
        "solutionSteps": [
          "17 cm = 17 × 10 = 170 mm",
          "Plus 4 mm erbij: 170 + 4 = 174 mm",
          "Check: 174 ÷ 10 = 17,4 cm ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 17 cm en 4 mm = 170 + 4 = 174 mm.",
          "1": "Je dacht waarschijnlijk dat je de komma gewoon verplaatst. Maar 17,4 mm is veel kleiner dan 17 cm! 17 cm = 170 mm, niet 17,4 mm. Onthoud: 1 cm = 10 mm.",
          "2": "Je dacht waarschijnlijk dat 1 cm = 100 mm. Maar 1 cm = 10 mm. Dus 17 cm = 170 mm, niet 1700 mm. Onthoud: gebruik het metrieke trapje.",
          "3": "Je dacht waarschijnlijk dat 1 cm = 1000 mm. Maar 1 cm = 10 mm. Je verwart dit misschien met 1 m = 1000 mm. Onthoud: cm naar mm = × 10."
        }
      }
    },
    {
      "id": "MET-LEN-NAUWKEURIG-002",
      "familyId": "MET-LEN-NAUWKEURIG",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_nauwkeurig",
      "questionType": "multiple_choice",
      "question": "Een timmerman meet een plank. De liniaal wijst 23 cm en 7 mm aan. Hoeveel is dat in centimeters met een komma?",
      "options": ["2,37 cm", "23,07 cm", "23,7 cm", "237 cm"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Millimeters als tienden van centimeters",
            "content": "1 mm = 0,1 cm. Dus 7 mm = 0,7 cm. Samen: 23 cm + 0,7 cm = 23,7 cm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "nauwkeurig_mm_als_tienden",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.lengte-komma-positie-fout", "label": "Komma op verkeerde plek (na verkeerd cijfer)", "optionIndex": 0 },
          { "id": "met.lengte-decimaal-extra-nul", "label": "Extra nul toegevoegd: 0,07 i.p.v. 0,7", "optionIndex": 1 },
          { "id": "met.lengte-komma-weggelaten", "label": "Komma weggelaten — getal niet omgerekend", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "7 mm = 0,7 cm (want 1 mm = 0,1 cm). Dus 23 cm en 7 mm = 23,7 cm. Waarom 0,7 en niet 0,07? Omdat millimeters tienden van centimeters zijn, niet honderdsten. Check: 23,7 × 10 = 237 mm = 230 + 7 ✓",
        "solutionSteps": [
          "23 cm blijft 23 cm",
          "7 mm = 7 × 0,1 cm = 0,7 cm",
          "Samen: 23 + 0,7 = 23,7 cm",
          "Check: 23,7 cm = 237 mm = 23 cm + 7 mm ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je de komma na de 2 zet. Maar 2,37 cm is veel kleiner dan 23 cm. Onthoud: de hele centimeters staan vóór de komma.",
          "1": "Je dacht waarschijnlijk dat je een nul moet toevoegen. Maar 7 mm = 0,7 cm, niet 0,07 cm. 0,07 cm zou 0,7 mm zijn — veel te klein. Onthoud: 1 mm = 0,1 cm.",
          "2": "Goed! 23 cm en 7 mm = 23,7 cm.",
          "3": "Je dacht waarschijnlijk dat je alles bij elkaar optelt zonder komma. Maar 237 cm = 2 meter 37 — dat is veel te lang voor een meting van 23 cm en 7 mm."
        }
      }
    },
    {
      "id": "MET-LEN-NAUWKEURIG-003",
      "familyId": "MET-LEN-NAUWKEURIG",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_nauwkeurig",
      "questionType": "multiple_choice",
      "question": "Welke meting is het nauwkeurigst?",
      "options": ["15 cm", "15,3 cm", "ongeveer 15 cm", "een beetje meer dan 15 cm"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Nauwkeurigheid bij meten",
            "content": "Hoe meer cijfers achter de komma, hoe nauwkeuriger. '15,3 cm' is nauwkeuriger dan '15 cm' omdat het ook de millimeters aangeeft.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "nauwkeurigheid_begrip",
      "variantIndex": 3,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.nauwkeurigheid-afgerond-vs-precies", "label": "Verwart afgerond getal met nauwkeurig", "optionIndex": 0 },
          { "id": "met.nauwkeurigheid-schatting-vs-meting", "label": "Schatting als nauwkeurige meting beschouwd", "optionIndex": 2 },
          { "id": "met.nauwkeurigheid-schatting-vs-meting", "label": "Vage omschrijving als meting beschouwd", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Bij nauwkeurig meten geldt de regel: hoe meer cijfers achter de komma, hoe preciezer de meting. '15,3 cm' geeft de millimeters aan (3 mm = 0,3 cm) en is daarmee het nauwkeurigst. '15 cm' is afgerond op hele centimeters — de echte lengte kan 14,5 tot 15,4 cm zijn. 'Ongeveer' en 'een beetje meer' zijn schattingen, geen metingen. Onthoud de meetregel: gebruik altijd getallen met decimalen als je nauwkeurig wilt meten.",
        "solutionSteps": [
          "Meetregel: meer decimalen = nauwkeuriger",
          "15,3 cm → nauwkeurig tot op de millimeter (0,1 cm) ✓",
          "15 cm → afgerond op hele centimeters (onnauwkeurigheid tot 0,5 cm)",
          "'Ongeveer 15 cm' → schatting, geen exacte meting",
          "'Een beetje meer dan 15 cm' → vaag, geen getal",
          "Conclusie: 15,3 cm is het nauwkeurigst"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 15 cm nauwkeurig genoeg is. Maar 15 cm is afgerond — het kan 14,5 tot 15,4 cm zijn. 15,3 cm is preciezer. Onthoud: meer cijfers = nauwkeuriger.",
          "1": "Goed! 15,3 cm is het nauwkeurigst — het geeft ook de millimeters aan.",
          "2": "Je dacht waarschijnlijk dat 'ongeveer' nauwkeurig is. Maar 'ongeveer' is een schatting, geen exacte meting. Onthoud: nauwkeurig meten = exacte getallen met komma.",
          "3": "Je dacht waarschijnlijk dat 'een beetje meer' nauwkeurig is. Maar dit is vaag — hoeveel meer? 15,3 cm geeft precies aan hoeveel meer. Onthoud: gebruik getallen, geen woorden."
        }
      }
    },
    {
      "id": "MET-LEN-NAUWKEURIG-004",
      "familyId": "MET-LEN-NAUWKEURIG",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_nauwkeurig",
      "questionType": "multiple_choice",
      "question": "Een leerling meet een lijn van 8,5 cm. Hoeveel millimeter is dat?",
      "options": ["850 mm", "8,5 mm", "80,5 mm", "85 mm"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "length",
            "from": "cm",
            "to": "mm",
            "value": 8.5
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetal omrekenen",
            "content": "1 cm = 10 mm. Dus 8,5 cm = 8,5 × 10 = 85 mm. Bij × 10 schuift de komma één plek naar rechts.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "nauwkeurig_komma_omrekenen",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.lengte-mm-cm-relatie-fout", "label": "Denkt 1 cm = 100 mm", "optionIndex": 0 },
          { "id": "met.lengte-komma-verschoven", "label": "Komma niet verschoven bij × 10", "optionIndex": 1 },
          { "id": "met.lengte-decimaal-gesplitst", "label": "Decimaal apart gehouden bij × 10", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "8,5 cm × 10 = 85 mm. Bij vermenigvuldigen met 10 schuift de komma één plek naar rechts: 8,5 → 85. Waarom ×10? Omdat 1 cm = 10 mm. Check: 85 mm ÷ 10 = 8,5 cm ✓",
        "solutionSteps": [
          "1 cm = 10 mm",
          "8,5 cm = 8,5 × 10 = 85 mm",
          "Komma schuift 1 plek naar rechts: 8,5 → 85",
          "Check: 85 ÷ 10 = 8,5 cm ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 1 cm = 100 mm. Maar 1 cm = 10 mm. Dus 8,5 × 10 = 85, niet 850. Onthoud: gebruik het metrieke trapje.",
          "1": "Je dacht waarschijnlijk dat de komma blijft staan. Maar 8,5 mm is veel kleiner dan 8,5 cm! Bij × 10 schuift de komma naar rechts. Onthoud: cm → mm = × 10.",
          "2": "Je dacht waarschijnlijk dat je de 5 apart houdt. Maar 8,5 × 10 = 85, niet 80,5. Bij × 10 schuift de hele komma. Onthoud: 8,5 × 10 = 85.",
          "3": "Goed! 8,5 cm = 85 mm."
        }
      }
    },
    {
      "id": "MET-LEN-NAUWKEURIG-005",
      "familyId": "MET-LEN-NAUWKEURIG",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "lengte",
      "subSkill": "lengte_nauwkeurig",
      "questionType": "fill_in",
      "question": "Een sleutelhanger is 4 cm en 6 mm lang. Hoeveel millimeter is dat? Typ je antwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["46", "46 mm", "46mm"],
        "caseSensitive": false,
        "placeholder": "? mm"
      },
      "stimulusAids": [
        {
          "type": "stairs",
          "data": {
            "type": "length",
            "from": "cm",
            "to": "mm",
            "value": 4.6
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cm en mm naar mm",
            "content": "1 cm = 10 mm. Dus 4 cm = 40 mm. Plus 6 mm = 46 mm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "nauwkeurig_cm_mm_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 1
      },
      "feedback": {
        "explanationText": "4 cm = 4 × 10 = 40 mm. Plus 6 mm = 40 + 6 = 46 mm. Waarom ×10? Omdat er 10 millimeter in 1 centimeter gaan. Check: 46 mm = 4 cm en 6 mm ✓",
        "solutionSteps": [
          "4 cm = 4 × 10 = 40 mm",
          "Plus 6 mm = 40 + 6 = 46 mm",
          "Check: 46 mm = 4 cm en 6 mm ✓"
        ]
      }
    }
  ]
}